<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card :header="$t('general.construction.spool_management.title')" header-tag="h3" class="bg-default-card">
                <data-table
                    v-if="tableLoaded"
                    :exportable = "false" title=""
                    :rows="getData.rowData"
                    :rowsColor="getData.rowColors"
                    :columns="columnData"
                    :perPage="perPage"
                    :rowsCount="rowsCount"
                    :currentPage="currentPage"
                    :pageCount="pageCount"
                    @rowClickDelete="onDeleteRow"
                    @rowClickCheck="onRowClickCheck"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    >
                </data-table>
            </b-card>

            <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
                {{ $t('messages.delete') }}
            </confirm-dialog>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueForm from "vue-form";
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';

import Multiselect from 'vue-multiselect';
Vue.component(Multiselect);

export default {
    name: 'spool_management',
    components: {
        DataTable,
        flatPickr,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
    },
    data() {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.spool_management.title'),
                    active: true
                }
            ],
            tableName: 'spool',
            tableNameTranslated: Vue.i18n.translate('general.construction.spool_management.title_modal'),
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            getData: {
                rowData: [],
                rowColors: [],
            },
            columnData: [
                {
                    label: Vue.i18n.translate('table.area'),
                    field: 'drawing.line.area',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.serial_no'),
                    field: 'drawing.line.serial_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'drawing.line.line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.iso_no'),
                    field: 'drawing.iso_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.spool_no'),
                    field: 'spool_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.storage'),
                    field: 'storage.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.x_axis'),
                    field: 'x_axis',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.y_axis'),
                    field: 'y_axis',
                    numeric: true,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.team_stored'),
                    field: 'team_store.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.user_stored'),
                    field: 'user_store.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.storage_date'),
                    field: 'storage_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.team_picked_up'),
                    field: 'team_pickup.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.user_picked_up'),
                    field: 'user_pickup.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pick_up_date'),
                    field: 'picked_up_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'progress_status',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.delayed'),
                    field: 'delayed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true,
                },
                {
                    label: Vue.i18n.translate('table.hold'),
                    field: 'hold',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.material_picked_up'),
                    field: 'material_picked_up',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.painting_done'),
                    field: 'painting_done',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.prefab_started'),
                    field: 'prefab_started',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.prefab_finished'),
                    field: 'prefab_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.prefab_visual_test'),
                    field: 'prefab_visual_test',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.prefab_checked'),
                    field: 'prefab_checked',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.prefab_ndt'),
                    field: 'prefab_ndt_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.prefab_pwht'),
                    field: 'prefab_pwht_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.ready_erection'),
                    field: 'ready_erection',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.spool_picked_up'),
                    field: 'spool_picked_up',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.erection_started'),
                    field: 'erection_started',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.welding_finished'),
                    field: 'welding_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.supports_installed'),
                    field: 'supports_installed',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.erection_visual_test'),
                    field: 'erection_visual_test',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.erection_checked'),
                    field: 'erection_checked',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.erection_ndt'),
                    field: 'erection_ndt_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.erection_pwht'),
                    field: 'erection_pwht_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.ready_pressure_test'),
                    field: 'ready_pressure_test',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: false
                },
                {
                    label: Vue.i18n.translate('table.partial_pressure_test'),
                    field: 'partial_pressure_test',
                    numeric: false,
                    showAsCheck: true,
                    width: '100px',
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.pressure_test_finished'),
                    field: 'pressure_test_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.reinstallment_done'),
                    field: 'reinstallment_done',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.painting_finished'),
                    field: 'painting_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                },
                {
                    label: Vue.i18n.translate('table.insulation_finished'),
                    field: 'insulation_finished',
                    numeric: false,
                    html: false,
                    showAsCheck: true,
                    width: '100px',
                    cursor: true
                }
            ],
            isLineLoading: false,
            currentLine: [],

            isUserStoreLoading: false,
            currentUserStore: [],

            isUserPickupLoading: false,
            currentUserPickup: [],

            isDrawingLoading: false,
            currentDrawing: [],

            isTeamStoreLoading: false,
            currentTeamStore: [],

            isStorageLoading: false,
            currentStorage: [],

            isTeamPickedUpLoading: false,
            currentTeamPickedUp: [],

            isProgressLoading: false,
            currentProgress: [],
            model: {
                line_id: null,
                drawing_id: null,
                user_store_id: null,
                user_pickup_id: null,
                storage_id: null,
                team_pickup_id: null,
                team_store_id: null,
                picked_up_date: null,
                storage_date: null,
                spool_no: null,
                hold: null,
                prefab_visual_test: null,
                prefab_checked: null,
                prefab_ndt_finished: null,
                prefab_pwht_finished: null,
                ready_erection: null,
                erection_visual_test: null,
                erection_checked: null,
                erection_ndt_finished: null,
                erection_pwht_finished: null,
                ready_pressure_test: null,
                partial_pressure_test: null,
                painting_finished: null,
                insulation_finished: null,
                remark1: null,
                remark2: null,
                remark3: null,
                x_axis: null,
                y_axis: null,
                material_picked_up: null,
                painting_done: null,
                prefab_started: null,
                prefab_finished: null,
                spool_picked_up: null,
                erection_started: null,
                welding_finished: null,
                supports_installed: null,
                pressure_test_finished: null,
                reinstallment_done: null,
                selectedTeamStored: {},
                selectedTeamPickedUp: {},
                selectedUserStore: {},
                selectedUserPickup: {},
                selectedProgress: {},
                selectedLine: {},
                selectedWeld: {},
                selectedScaffolding: {},
            },
        }
    },
    computed: {
        statuses: {
            get: function () {
                let statuses = this.$store.getters.getSpoolStatus;
                return statuses;
            }
        }
    },
    watch: {
        statuses: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        }
    },
    mounted () {
        this.onLoadTable();

        if(this.$store.state.go_back_url == 'isometric_management') {
            this.$refs.saveModal.show();
        }
    },
    methods: {
        onRowClickCheck(row, index, column) {
            var not_checkable = [
                'hold',
                'prefab_visual_test',
                'prefab_checked',
                'prefab_ndt_finished',
                'prefab_pwht_finished',
                'ready_erection',
                'erection_visual_test',
                'erection_checked',
                'erection_ndt_finished',
                'erection_pwht_finished',
                'ready_pressure_test',
            ];
            var tmp = true;
            not_checkable.forEach(check => {
                if (column === check) {
                    tmp = false;
                }
            })

            if (!tmp) {
                return false;
            }

            if (column == 'delayed') {
                if(row.delayed == true && row.delay != null) {
                    http.route('delay/'+row.delay.id).patch({
                        end_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
                        title: row.delay.title,
                        delay_date: row.delay.delay_date,
                        discipline_id: row.delay.discipline_id
                    }, true).then(response => {
                        if(!response.data) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.delay_updated'));
                        }
                    });
                } else {
                    this.$router.push({name: 'delays'});
                }
            } else if (row && column != 'hold') {
                let tmp_value = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                let put_data = row;

                put_data[column] = tmp_value;

                http.route('spool/' + row.id).patch(put_data, true).then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                        this.onLoadTable();
                    } else {
                        row[column.toString()] = tmp_value;
                        // this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                    }
                });
            }
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                if (response.isError == false) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach((field, key)  => {
                        this.getData.rowColors[key] = {};

                        if((field.line == null || field.line == '')) {
                            field.line = { 'line_number': '',
                                            'serial_no': '',
                                            'area': ''
                            };
                        }

                        if((field.drawing == null || field.drawing == '')) {
                            field.drawing = { 'drawing_number': '' };
                        }

                        if((field.weld == null || field.weld == '')) {
                            field.weld = { 'weld_no': '' };
                        }

                        if((field.team_pickup == null || field.team_pickup == '')) {
                            field.team_pickup = { 'name': '' };
                        }

                        if((field.team_store == null || field.team_store == '')) {
                            field.team_store = { 'name': '' };
                        }

                        if((field.project_setting == null || field.project_setting == '')) {
                            field.project_setting = { 'value': '' };
                        }

                        if((field.user_pickup == null || field.user_pickup == '')) {
                            field.user_pickup = { 'fullname': '' };
                        }

                        if((field.user_store == null || field.user_store == '')) {
                            field.user_store = { 'fullname': '' };
                        }

                        if((field.storage == null || field.storage == '')) {
                            field.storage = { 'name': '' };
                        }

                        if(field.hold) {
                            this.getData.rowColors[key]['hold'] = '#ff471a';
                        }
                    });
                    this.getData.rowData = data;
                    this.tableLoaded  = true;
                } else {
                    let msg = '';
                    Object.keys(response.errorMessage).forEach(key => {
                        msg += Vue.i18n.translate(response.errorMessage[key]) + "\n";
                    });
                    this.errorMsg(msg);
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        returnTo() {
            if(this.$store.state.go_back_url) {
                this.$store.commit('SET_CAMEFROM', "spool_management");
                this.$router.push({name: this.$store.state.go_back_url, params: {id: this.$route.params.id}});
            }
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/project/construction/spool_management/spool_management.vue